/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-bitwise */
import { IonRouterOutlet, LoadingController } from '@ionic/angular';
import {
  Component,
  AfterViewInit,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { NavController, Platform, ViewWillEnter } from '@ionic/angular';
import { RestService } from '../../services/rest.service';
import { Events } from '../../services/events.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { Subject, forkJoin, takeUntil } from 'rxjs';
import { App } from '@capacitor/app';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuController } from '@ionic/angular';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { SelectOption } from '@bcl/design-system';
import { BackButtonService } from 'src/app/services/back-button.service';
import { TaskFilterService } from 'src/app/services/task-filter.service';
import { AccordionService } from 'src/app/services/accordion.service';
import { AreaApiService } from 'src/app/pages/area/area.service';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  styleUrls: ['./home.scss'],
})
export class HomePage
  implements AfterViewInit, OnInit, OnDestroy, ViewWillEnter
{
  public authorized: boolean;
  public uid = '';
  public authorizing: boolean;
  public username: string;
  public email: string;
  public componentName: string;

  public userID: number;
  public errorMessage: string;
  public selectedLanguage = '';

  public tabValue = 1;
  public errorQuestionnaire = '';
  public errorVisits = '';
  public timesheetLabels: SelectOption[] = [];

  // Warehouse options loaded once for all date components
  public warehouseOptions: SelectOption[] = [];
  public warehouseOptionsLoaded = false;
  public warehouseOptionsRefreshing = false;

  componentDestroyed$: Subject<boolean> = new Subject();

  baseDate: Date = new Date();

  visits: any[] = [];
  eljakimVisits: any[] = [];
  isLoadingPresenting = false;
  public loadingDialog: HTMLIonLoadingElement;
  nonVisits: any[] = [];
  showAll = false;
  lastWeek = false;

  private cachedFilteredVisits: any[] = [];
  private lastFilterState = { showAll: false, eljakimVisitsLength: 0 };

  constructor(
    public navCtrl: NavController,
    private rest: RestService,
    public events: Events,
    public platform: Platform,
    private auth: AuthService,
    private dataProvider: DataProviderService,
    private loadingController: LoadingController,
    private routerOutlet: IonRouterOutlet,
    private translatePipe: TranslatePipe,
    private menuCtrl: MenuController,
    private dictionaryService: DictionaryService,
    private backButtonService: BackButtonService,
    private taskFilterService: TaskFilterService,
    private accordionService: AccordionService,
    private cdr: ChangeDetectorRef,
    private areaApiService: AreaApiService
  ) {
    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    });
  }

  get filteredEljakimVisits() {
    if (this.showAll) {
      return this.eljakimVisits;
    }

    const currentState = {
      showAll: this.showAll,
      eljakimVisitsLength: this.eljakimVisits.length,
    };

    this.cachedFilteredVisits = this.eljakimVisits
      .map((dateGroup) => ({
        ...dateGroup,
        allObjects: dateGroup.objects,
        objects: dateGroup.objects.filter((visit) => {
          if (visit.nonVisit) {
            return true;
          }
          return !visit.isCompleted || visit.isReopened;
        }),
      }))
      .filter((dateGroup) => dateGroup.objects.length > 0);

    this.lastFilterState = currentState;

    return this.cachedFilteredVisits;
  }

  onShowAllChange(): void {
    this.taskFilterService.setShowAll(this.showAll);
    // Force open the first accordion item when filter changes
    setTimeout(() => {
      const firstAccordionId = `visit-${this.filteredEljakimVisits[0]?.date}`;
      this.accordionService.openItem(firstAccordionId);
    }, 0);
  }

  trackByVisitDate(index: number, visit: any): string {
    return `${visit.date}-${this.showAll}-${visit.objects.length}`;
  }

  onLastWeekChange(): void {
    this.taskFilterService.setLastWeek(this.lastWeek);
    this.getData(true);
  }

  ionViewWillEnter(): void {
    this.menuCtrl.enable(true);
    this.menuCtrl.close();
    this.backButtonService.hideBackButton();

    this.refreshWarehouseOptions();
  }

  ngAfterViewInit(): void {}

  ngOnInit() {
    this.backButtonService.hideBackButton();

    this.accordionService.clearGroup('home-visits-tab1');
    this.accordionService.clearGroup('home-visits-lastweek');

    this.rest.email$.subscribe((email) => {
      this.email = email;
    });

    this.showAll = this.taskFilterService.getShowAll();

    // Subscribe to showAll changes from other pages
    this.taskFilterService.showAll$
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((showAll) => {
        if (this.showAll !== showAll) {
          // Force open the first accordion item when filter changes
          setTimeout(() => {
            const firstAccordionId = `visit-${this.filteredEljakimVisits[0]?.date}`;
            this.accordionService.openItem(firstAccordionId);
          }, 0);
        }
        this.showAll = showAll;
      });

    this.getData();
  }

  ngOnDestroy(): void {
    this.loadingDialog.dismiss();
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  logout() {
    this.auth.logoutNew();
  }

  doRefresh(event) {
    this.getData(true, event);
  }

  generateUUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      (c) => {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  public async getData(refreshFromApi: boolean = true, event = null) {
    if (!event) {
      this.isLoadingPresenting = true;
      await this.showLoading();
    }
    const eljakimobservable = this.dataProvider
      .getEljakimJobsPlan(
        this.email,
        this.baseDate,
        refreshFromApi,
        this.lastWeek
      )
      .pipe(takeUntil(this.componentDestroyed$));

    const visitsobservable = this.dataProvider
      .getJobsPlan(this.baseDate, refreshFromApi)
      .pipe(takeUntil(this.componentDestroyed$));

    const nonVisitsobservable = this.dataProvider
      .getNonVisitsPlan(
        this.email,
        this.baseDate,
        refreshFromApi,
        this.lastWeek
      )
      .pipe(takeUntil(this.componentDestroyed$));

    const timesheetobservable =
      this.dictionaryService.getDictionaryItemsByKey('PC.TIMESHEET.LABEL');

    const warehouseOptionsObservable =
      this.areaApiService.getLocationDetailsOptions();

    forkJoin([
      eljakimobservable,
      visitsobservable,
      timesheetobservable,
      nonVisitsobservable,
      warehouseOptionsObservable,
    ]).subscribe(([result1, result2, result3, result4, result5]) => {
      result1.forEach((item) => {
        item.nonVisit = false;
        item.plannedStartTime = item.plannedStartTime?.slice(0, 5);
        item.plannedEndTime = item.plannedEndTime?.slice(0, 5);
        item.visitTypeTab = 2;
      });
      const eljakimWithProperty = result1;
      result4.forEach((item) => {
        item.nonVisit = true;
        item.visitTypeTab = 2;
      });
      const nonVisitsWithProperty = result4;

      const combinedEljakimVisits = [
        ...eljakimWithProperty,
        ...nonVisitsWithProperty,
      ];
      this.eljakimVisits = this.splitEljakimObjectsByDate(
        combinedEljakimVisits
      );

      this.cachedFilteredVisits = [];

      this.visits = this.splitObjectsByDate(result2);
      this.timesheetLabels = result3.map((label) => ({
        value: label.value,
        label: label.name,
      }));

      this.warehouseOptions = result5.monitor.product.warehouses || [];
      this.warehouseOptionsLoaded = true;

      if (this.isLoadingPresenting) {
        this.isLoadingPresenting = false;
        this.loadingDialog.dismiss();
      }
      if (event) {
        event.target.complete();
      }
    });
  }

  public splitObjectsByDate(inputArray) {
    const dateArrays = {};

    inputArray?.forEach((item) => {
      const dateString = item.inspectionDate;
      item.visitTypeTab = 1;
      if (!dateArrays[dateString]) {
        dateArrays[dateString] = [];
      }
      dateArrays[dateString].push(item);
    });
    const resultArray = Object.entries(dateArrays).map(([date, objects]) => ({
      date,
      objects,
    }));

    return resultArray.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
  }

  public splitEljakimObjectsByDate(inputArray) {
    const dateArrays = {};

    inputArray?.forEach((item) => {
      const dateString = item.planningDate;

      if (!dateArrays[dateString]) {
        dateArrays[dateString] = [];
      }
      dateArrays[dateString].push(item);
    });

    const resultArray = Object.entries(dateArrays).map(([date, objects]) => ({
      date,
      objects,
    }));

    return resultArray.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
  }

  async showLoading() {
    this.loadingDialog = await this.loadingController.create({
      message: this.translatePipe.transform('LOADING'),
    });

    this.loadingDialog.present();
  }

  public onDataRefresh(): void {
    this.getData(true);
  }

  private refreshWarehouseOptions(): void {
    if (this.warehouseOptionsLoaded) {
      this.warehouseOptionsRefreshing = true;
      this.areaApiService
        .getLocationDetailsOptions()
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe({
          next: (options) => {
            this.warehouseOptions = options.monitor.product.warehouses || [];
            this.warehouseOptionsRefreshing = false;
          },
          error: (error) => {
            console.error('Error refreshing warehouse options:', error);
            this.warehouseOptionsRefreshing = false;
          },
        });
    }
  }
}
